"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _metadata = _interopRequireDefault(require("./metadata"));

var _author = _interopRequireDefault(require("./author"));

var _elements = require("../../elements");

var _utils = require("../../utils");

var styles = {
  "container": "styles-container-2Sli1",
  "title": "styles-title-1k6Ib",
  "thumbnail": "styles-thumbnail-1xurx",
  "thumbnail-caption": "styles-thumbnail-caption-2Qdvz",
  "thumbnail-caption-empty": "styles-thumbnail-caption-empty-VoVAO",
  "content": "styles-content-35LN7",
  "thumbnailCaption": "styles-thumbnail-caption-2Qdvz",
  "thumbnailCaptionEmpty": "styles-thumbnail-caption-empty-VoVAO"
};
var texts = {
  pdfAvailable: 'Get PDF',
  linkAvailable: 'Access PDF',
  metadataOnly: 'No full text'
};
var PREFIX = 'work';
var labels = {
  author: 'Author',
  fieldOfStudy: 'Field of study',
  publicationDate: 'Publication date',
  publicationVenue: 'Publication venue'
};

var formatDate = function formatDate(date) {
  return date === null || date === void 0 ? void 0 : date.toString();
};

var SearchResult = function SearchResult(_ref) {
  var children = _ref.children,
      id = _ref.id,
      className = _ref.className,
      _ref$data = _ref.data;
  _ref$data = _ref$data === void 0 ? {} : _ref$data;
  var title = _ref$data.title,
      _ref$data$author = _ref$data.author,
      author = _ref$data$author === void 0 ? [] : _ref$data$author,
      publicationDate = _ref$data.publicationDate,
      publicationVenue = _ref$data.publicationVenue,
      fieldOfStudy = _ref$data.fieldOfStudy,
      metadataLink = _ref$data.metadataLink,
      fullTextLink = _ref$data.fullTextLink,
      thumbnailUrl = _ref$data.thumbnailUrl,
      htmlProps = (0, _objectWithoutProperties2["default"])(_ref, ["children", "id", "className", "data"]);

  var idFor = function idFor(scope) {
    return "".concat(id, "-").concat(scope);
  };

  return /*#__PURE__*/_react["default"].createElement(_elements.Card, (0, _extends2["default"])({
    id: "".concat(PREFIX, "-").concat(id),
    className: _utils.classNames.use(styles.container).join(className),
    itemScope: true,
    itemType: "https://schema.org/ScholarlyArticle"
  }, htmlProps), /*#__PURE__*/_react["default"].createElement(_elements.Heading, {
    level: "3",
    className: styles.title,
    itemProp: "name"
  }, metadataLink ? /*#__PURE__*/_react["default"].createElement(_elements.Link, {
    href: metadataLink
  }, title) : title), /*#__PURE__*/_react["default"].createElement(_metadata["default"], null, /*#__PURE__*/_react["default"].createElement(_metadata["default"].Item, {
    id: idFor('author'),
    label: labels.author
  }, /*#__PURE__*/_react["default"].createElement(_author["default"], {
    "aria-label": labels.author,
    authors: author
  })), /*#__PURE__*/_react["default"].createElement(_metadata["default"].Item, {
    id: idFor('venue'),
    label: labels.publicationVenue
  }, publicationVenue), /*#__PURE__*/_react["default"].createElement(_metadata["default"].Item, {
    id: idFor('publication-date'),
    label: labels.publicationDate,
    itemProp: "dataPublished"
  }, formatDate(publicationDate)), /*#__PURE__*/_react["default"].createElement(_metadata["default"].Item, {
    id: idFor('field'),
    label: labels.fieldOfStudy,
    itemProp: "dataPublished"
  }, fieldOfStudy)), /*#__PURE__*/_react["default"].createElement("figure", {
    className: styles.thumbnail
  }, fullTextLink != null ? /*#__PURE__*/_react["default"].createElement(_elements.Link, {
    href: fullTextLink
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: thumbnailUrl,
    alt: ""
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: styles.thumbnailCaption
  }, texts.pdfAvailable)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("img", {
    src: thumbnailUrl,
    alt: ""
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: _utils.classNames.use(styles.thumbnailCaption, styles.thumbnailCaptionEmpty)
  }, texts.metadataOnly))), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.content
  }, children));
};

SearchResult.displayName = "SearchResult";
SearchResult.propTypes = {
  id: _propTypes["default"].string.isRequired,
  data: _propTypes["default"].shape({
    id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    title: _propTypes["default"].string,
    author: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      name: _propTypes["default"].string
    })),
    publicationDate: _propTypes["default"].string,
    publicationVenue: _propTypes["default"].string,
    metadataLink: _propTypes["default"].string,
    fullTextLink: _propTypes["default"].string,
    thumbnailUrl: _propTypes["default"].string
  })
};
var _default = SearchResult;
exports["default"] = _default;